import { createRoute } from '@tanstack/react-router';
import { groupParentRoute } from 'pages/group/groupParentRoute';

export const groupPharmacyListNewRoute = createRoute({
  getParentRoute: () => groupParentRoute,
  path: '/pharmacy_lists/new',
}).lazy(() =>
  import('pages/group/PharmacyLists/PharmacyListIngestionPage/PharmacyListIngestionPage').then(
    (d) => d.Route
  )
);
